import React, { useRef } from "react";
import * as Styles from "../styles/Collapsable";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { BnbLabel } from "../../../../utils/labels";

type CollapsableProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    icon?: React.ReactNode;
    ctaLabel: React.ReactNode;
    content: React.ReactNode;
    active: boolean;
    multiRowHeader?: boolean;
    onChange: (isExpanded: boolean) => void;
    onTrack: () => void;
};

const Collapsable = (props: CollapsableProps): JSX.Element => {
    const { title, subtitle, content, ctaLabel, icon, multiRowHeader, onChange, onTrack, active } = props;
    const detailsRef = useRef<HTMLDetailsElement>(null);

    const hasIcon = !!icon;

    const onToggle = (event: React.SyntheticEvent<HTMLElement, Event>): void => {
        onChange((event.target as HTMLDetailsElement).open);
    };

    const onClick = (): void => {
        if (detailsRef.current) {
            const detailElem = detailsRef.current as HTMLDetailsElement;
            detailElem.toggleAttribute("open");
            onChange(active);
        }
    };

    return (
        <Styles.StyledCollapsable ref={detailsRef} open={active} onToggle={onToggle}>
            {/* Only tracks clicks on the buttons for tracking purposes as the active state is determined externally */}
            <Styles.CollapsableHeader onClick={onTrack} multiRowHeader={multiRowHeader}>
                <Styles.CollapsableHeaderContent $icon={hasIcon}>
                    {icon}
                    <Styles.CollapsableTitleSection>
                        {title}
                        {subtitle}
                    </Styles.CollapsableTitleSection>
                </Styles.CollapsableHeaderContent>
                {active ? (
                    <Button.Outline type="button" width={1} m={0} onClick={onClick}>
                        <Text.Button>
                            <BnbLabel label="close" />
                        </Text.Button>
                    </Button.Outline>
                ) : (
                    <Button.Primary type="button" width={1} m={0} onClick={onClick}>
                        <Text.Button>{ctaLabel}</Text.Button>
                    </Button.Primary>
                )}
            </Styles.CollapsableHeader>
            <Styles.CollapsableContent>{content}</Styles.CollapsableContent>
        </Styles.StyledCollapsable>
    );
};

export default Collapsable;
